import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { VinculosAPI } from '../../../../shared/http-requests';
import { connect } from 'react-redux';

const RestrictCollection = ({userSessionRx,userLocalRx}) => {
    const { codAcervo } = useParams();
    const history = useHistory()
    const [loading, setLoading] = useState(true);
    const isAuthenticated = userSessionRx || userLocalRx;

    useEffect(() => {
        if(codAcervo){

            VinculosAPI.buscarLinksAcervos(codAcervo).then((response) => {
                const { data } = response;
                if(data && data?.length > 0) {
                    const { links } = data[0];
                    const restricted = links.filter(link => ['acesso restrito', 'acesso restrito - visualizar'].includes(link?.descricao?.trim()?.toLowerCase()))
                    if(restricted.length > 0 ){
                        if(isAuthenticated){
                            history.replace(`/acesso-restrito/${codAcervo}`);
                            return;
                        }
                        setLoading(false)
                        history.replace(`/login?redirect=/acesso-restrito/${codAcervo}&destination=C&origin=restricted_access`);
                    }else{
                        history.replace(`/acervo/${codAcervo}`);
                    }
                }
            }).catch(() => {
                setLoading(false)
                history.replace(`/`)
            })
        }
    }, [codAcervo, isAuthenticated]);


    return (
        <div>
            {loading ? 'Carregando ...'  : ''}
        </div>
    )
}


const mapStateToProps = state => ({
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
});


export default connect(mapStateToProps)(RestrictCollection);
